// 系统环境参数
let systemKey = "portal-im";
let domain =
    process.env.NODE_ENV == "development" ?
    "https://t.witsbox.com" :
    location.protocol + "//" + location.host;
let domainApi = `${domain}/api`;
let wxDomain = "https://wx.dailyedu.com.cn";
let zsDomain = "https://w.witsbox.com/api";
console.log("location.host", location.host);
const WITSBOX_ENV_PARAM = {
		serviceId:'1008611',
    domain: domain,
    host: location.host,
    smbdomain: `${domain}/${systemKey}`,
    IMAccountPrefix: domain == 'https://t.witsbox.com' ? 'test' : 'prod', // 正式prod 测试test
    systemKey: systemKey,
    wxStuUrl: `${wxDomain}/${systemKey}`, // 正式wx.dailyedu.com.cn 测试t.witsbox.com
    loginPage: `${domain}/${systemKey}/`,
    baseUrl: domainApi,
    zsDomain: zsDomain,
    examUrl: `${domain}/exam`,
    neoUrl: `${domain}/neo`,
    hostUrl: process.env.NODE_ENV == "development" ?
        "http://localhost:8080/#" :
        `${domain}/${systemKey}/#`,
 
    client: {},
    ossObject: {},
    ossKeyFolder: {
        Certificate: "Certificate" //证书
    },

};
export default WITSBOX_ENV_PARAM;


//////////////////
// WEBPACK FOOTER
// ./utils/common.js
// module id = null
// module chunks = 